import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

const LoginPage: React.FC = () => {
    const [formData, setFormData] = useState({
        email: '',
        password: ''
    });
    const [error, setError] = useState('');
    const [loading, setLoading] = useState(false);

    const { login } = useAuth();
    const navigate = useNavigate();

    const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        const { name, value } = e.target;
        setFormData(prev => ({
            ...prev,
            [name]: value
        }));
    };

    const handleSubmit = async (e: React.FormEvent) => {
        e.preventDefault();
        setError('');
        setLoading(true);

        try {
            await login(formData.email, formData.password);
            navigate('/');
        } catch (err: any) {
            setError(err.message || 'Erreur lors de la connexion');
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="min-h-screen bg-eldai-gray-light flex items-center justify-center py-12 px-4 sm:px-6 lg:px-8">
            <div className="max-w-md w-full space-y-8">
                <div>
                    <div className="text-center">
                        <h1 className="text-3xl font-bold text-eldai-blue">Eldaï</h1>
                        <h2 className="mt-6 text-2xl font-semibold text-eldai-blue">
                            Connexion à votre compte
                        </h2>
                        <p className="mt-2 text-sm text-eldai-gray">
                            Ou{' '}
                            <Link
                                to="/register"
                                className="font-medium text-eldai-blue hover:text-eldai-yellow"
                            >
                                créez un nouveau compte
                            </Link>
                        </p>
                    </div>
                </div>

                <form className="mt-8 space-y-6" onSubmit={handleSubmit}>
                    {error && (
                        <div className="bg-red-100 border border-red-400 text-red-700 px-4 py-3 rounded">
                            {error}
                        </div>
                    )}

                    <div className="space-y-4">
                        <div>
                            <label htmlFor="email" className="block text-sm font-medium text-eldai-blue">
                                Email
                            </label>
                            <input
                                id="email"
                                name="email"
                                type="email"
                                required
                                value={formData.email}
                                onChange={handleChange}
                                className="mt-1 appearance-none relative block w-full px-3 py-2 border border-eldai-gray placeholder-eldai-gray text-eldai-blue rounded-md focus:outline-none focus:ring-eldai-yellow focus:border-eldai-yellow focus:z-10 sm:text-sm"
                                placeholder="votre@email.com"
                            />
                        </div>

                        <div>
                            <label htmlFor="password" className="block text-sm font-medium text-eldai-blue">
                                Mot de passe
                            </label>
                            <input
                                id="password"
                                name="password"
                                type="password"
                                required
                                value={formData.password}
                                onChange={handleChange}
                                className="mt-1 appearance-none relative block w-full px-3 py-2 border border-eldai-gray placeholder-eldai-gray text-eldai-blue rounded-md focus:outline-none focus:ring-eldai-yellow focus:border-eldai-yellow focus:z-10 sm:text-sm"
                                placeholder="Votre mot de passe"
                            />
                        </div>
                    </div>

                    <div className="flex items-center justify-between">
                        <div className="text-sm">
                            <button
                                type="button"
                                className="font-medium text-eldai-blue hover:text-eldai-yellow"
                                onClick={() => {/* TODO: Implement forgot password */ }}
                            >
                                Mot de passe oublié ?
                            </button>
                        </div>
                    </div>

                    <div>
                        <button
                            type="submit"
                            disabled={loading}
                            className="group relative w-full flex justify-center py-2 px-4 border border-transparent text-sm font-medium rounded-md text-eldai-blue bg-eldai-yellow hover:bg-eldai-blue hover:text-white focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-eldai-yellow disabled:opacity-50 disabled:cursor-not-allowed transition-colors"
                        >
                            {loading ? 'Connexion...' : 'Se connecter'}
                        </button>
                    </div>

                    <div className="text-center">
                        <span className="text-sm text-eldai-gray">
                            Vous n'avez pas de compte ?{' '}
                            <Link
                                to="/register"
                                className="font-medium text-eldai-blue hover:text-eldai-yellow"
                            >
                                Inscrivez-vous maintenant
                            </Link>
                        </span>
                    </div>
                </form>
            </div>
        </div>
    );
};

export default LoginPage;
